


































/** Пустой выбор значит «уровень не участвует», а не «все»; служебный ноль режется здесь */
import { Component, Prop, Vue } from 'vue-property-decorator';

import { MmSelectOption } from '../types/domain';

const SENTINEL_VALUE = 0;

@Component
export default class MmLevelSelect extends Vue {
	@Prop({ required: true }) readonly items!: MmSelectOption[];

	/** Значение приходит без служебного нуля — только настоящие идентификаторы */
	@Prop({ required: true }) readonly value!: number[];

	@Prop({ default: 'notSelected' }) readonly mode!: 'notSelected' | 'manual';

	@Prop({ default: false }) readonly disabled!: boolean;
	@Prop({ default: false }) readonly loading!: boolean;
	@Prop({ default: '' }) readonly placeholder!: string;

	SENTINEL_VALUE = SENTINEL_VALUE;

	get hasNotSelectedOption(): boolean {
		return this.mode === 'notSelected';
	}

	get notSelectedLabel(): string {
		return this.$t('priceMonitoring.mobileMonitoring.filters.notSelected') as string;
	}

	get placeholderText(): string {
		if (this.placeholder !== '') {
			return this.placeholder;
		}

		return this.mode === 'notSelected'
			? this.notSelectedLabel
			: (this.$t('priceMonitoring.mobileMonitoring.filters.selectManually') as string);
	}

	get innerValue(): number[] {
		if (this.value.length === 0 && this.mode === 'notSelected') {
			return [SENTINEL_VALUE];
		}

		return this.value;
	}

	filterOption(input: string, option: any): boolean {
		const label = option && option.componentOptions && option.componentOptions.propsData
			? String(option.componentOptions.propsData.label)
			: '';

		return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	}

	/** Сентинел означает пустой уровень; схлопывания «выбраны все — сентинел» здесь намеренно нет */
	handleChange(selected: number[]): void {
		const raw = selected ? selected : [];
		const justPickedSentinel = raw.length > 0 && raw[raw.length - 1] === SENTINEL_VALUE;

		if (justPickedSentinel) {
			this.emitValue([]);

			return;
		}

		this.emitValue(raw.filter((item) => item !== SENTINEL_VALUE));
	}

	private emitValue(next: number[]): void {
		// Не эмитим, если ничего не изменилось: иначе `@Watch` в секции
		// уходит в цикл «эмит → присвоение → эмит».
		if (this.isSameValue(next, this.value)) {
			return;
		}

		this.$emit('change', next);
	}

	private isSameValue(a: number[], b: number[]): boolean {
		if (a.length !== b.length) {
			return false;
		}

		const left = a.slice().sort();
		const right = b.slice().sort();

		for (let i = 0; i < left.length; i += 1) {
			if (left[i] !== right[i]) {
				return false;
			}
		}

		return true;
	}
}
